/**
 * フォームの情報
 */
const headTitleList: any[] = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "理由",
  },
  {
    headTitle: "廃止・休止・経営移管年月日",
  },
  {
    headTitle: "職員の異動状況",
  },
  {
    headTitle: "経営移管後の共済契約署名",
  },
  {
    headTitle: "廃止・休止が確認できる書類",
  },
];
const memoTitleList: any[] = [
  {
    headTitle: "担当者名",
  },
  {
    headTitle: "状態",
  },
  {
    headTitle: "作成日時",
  },
  {
    headTitle: "処理コメント",
  },
];

export { headTitleList, memoTitleList };
